import { nl2ul } from "../helper/common";
import SkorAi2 from "../assets/img/skorAI_logo2.gif";
import useTranslator from "../hooks/useTranslator";
import { RowButton, Modal, Notice } from "./design";
import "./summary.css";

const Summary = (props) => {
  const { _t } = useTranslator();
  const {
    user,
    showReportIcons,
    setShowChatBot,
    llShowOnly,
    isOpen,
    setIsOpen,
  } = props;

  if (!(showReportIcons && llShowOnly && isOpen)) return null;

  const close = () => setIsOpen(false);
  const summary =
    localStorage.getItem("i18nextLng") === "es"
      ? user?.profileSummaryEs
      : user?.profileSummary;

  return (
    <Modal
      open
      onClose={close}
      size="lg"
      align="start"
      title={_t("profileSummary")}
      closeLabel={_t("close")}
    >
      <div className="summary-modal">
        <div
          className="summary-modal__list"
          dangerouslySetInnerHTML={{
            __html: nl2ul(summary, "two-column-list"),
          }}
        />
        <Notice>
          <strong>{_t("disclaimer")}:</strong>{" "}
          {_t(
            "summaryGeneratedByAiThroughSkorAiDataInformationMayBeProneToError",
            "Disclaimer text"
          )}
        </Notice>
        {user?.about_me && (
          <div>
            <h3 className="summary-modal__heading">
              {_t("tenantInputContext")}
            </h3>
            <p className="summary-modal__text">{user.about_me}</p>
          </div>
        )}
        <RowButton
          type="button"
          className="summary-modal__ask"
          onClick={() => {
            close();
            setShowChatBot(true);
          }}
        >
          <img src={SkorAi2} alt="Skor AI" />
        </RowButton>
      </div>
    </Modal>
  );
};

export default Summary;
